import React, {useEffect, useState} from "react";
import
  PropTypes
from 'prop-types';
import {
  DetailsSection,
  MainDetailsSection
 } from './MainSection.styles'

import { RegistrationLayout } from './registration/RegistrationLayout';
import { PopUp } from "./popUp";
import { ErrorPage } from "./errorPage/ErrorPage";
import { NotificationAlerts } from "./notificationAlerts/notificationAlerts";
import { ForgotUsername } from "./forgotUsername/ForgotUsername";
import { ForgotPassword } from "./forgotPassword/ForgotPassword";
import { ChangePassword } from "./changePassword/ChangePassword";

export const MainSection = (props) => {
  const [ infoObj, setInfoObj ] = useState({});
  const [ displayView, setDisplayView ] = useState({});
  const [ viewPopup, setViewPopup ] = useState('flex');
  const [ refDetails, setRefDetails ] = useState({});
  const [ accountType, setAccountType ] = useState('');
  const [ username, setUsername ] = useState('');
  const [ email, setEmail ] = useState('');
  const [ isError, setIsError ] = useState();
  const [ isSuccess, setIsSuccess ] = useState();
  const [ notificationAlertDisplay, setNotificationAlertDisplay ] = useState('');
  const [ notificationAlertMessage, setNotificationAlertMessage ] = useState('');

  useEffect(() => {
    displayView?.currentDisplay &&
      props.setCurrentPage(displayView?.currentDisplay);

      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
  }, [displayView])

  return (
    <>
    { 
      notificationAlertDisplay &&
      <NotificationAlerts
        display={notificationAlertDisplay}
        setDisplay={setNotificationAlertDisplay}
        notificationText={notificationAlertMessage}
      />
    }
    {
      isSuccess &&
      <PopUp
        viewPopup={viewPopup}
        setViewPopup={setViewPopup}
        refDetails={refDetails}
        setRefDetails={setRefDetails}
        accountType={accountType}
        setAccountType={setAccountType}
        displayView={displayView}
        setDisplayView={setDisplayView}
        isChangePassword={props.currentPage === 'FORGET_USERNAME' ? true : false}
        message={props.currentPage === 'FORGET_USERNAME' ? ('Your username has been sent to '+ email) : 'You have successfully reset your username.'}
      />
    }
    <MainDetailsSection>
      <DetailsSection currentPage ={props.currentPage} regSecondPhase={props.regSecondPhase}>
        {
          isError &&
          <ErrorPage setIsError={setIsError}/>
        }
        { props.currentPage === 'REGISTER' &&
          <RegistrationLayout
            infoObj={infoObj}
            setInfoObj={setInfoObj}
            displayView={displayView}
            setDisplayView={setDisplayView}
            refDetails={refDetails}
            setRefDetails={setRefDetails}
            setAccountType={setAccountType}
            accountType={accountType}
            isError={isError}
            setIsError={setIsError}
            setIsSuccess={setIsSuccess}
            isSuccess={isSuccess}
            setRegSecondPhase={props.setRegSecondPhase}
            currentPage={props.currentPage}
            setDisplay={setNotificationAlertDisplay}
            notificationText={notificationAlertMessage}
            setNotificationText={setNotificationAlertMessage}
          />
        }

        { props.currentPage === 'FORGET_USERNAME' &&
          <ForgotUsername
            setEmail={setEmail}
            setDisplayView={setDisplayView}
            displayView={displayView}
            notificationAlertDisplay={notificationAlertDisplay}
            setNotificationAlertDisplay={setNotificationAlertDisplay}
            notificationText={notificationAlertMessage}
            setNotificationText={setNotificationAlertMessage}
            setIsSuccess={setIsSuccess}
            isSuccess={isSuccess}
          />
        }
        { props.currentPage === 'FORGET_PASSWORD' &&
          <ForgotPassword 
            setDisplayView={setDisplayView}
            displayView={displayView}
            username={username}
            setUsername={setUsername}
            display={notificationAlertDisplay}
            setDisplay={setNotificationAlertDisplay}
            notificationText={notificationAlertMessage}
            setNotificationText={setNotificationAlertMessage}
          />
        }
        {
          props.currentPage === 'FORGET_PASSWORD_CHANGE' && 
          <ChangePassword
            setDisplayView={setDisplayView}
            displayView={displayView}
            username={username}
            setUsername={setUsername}
            notificationAlertDisplay={notificationAlertDisplay}
            setNotificationAlertDisplay={setNotificationAlertDisplay}
            notificationText={notificationAlertMessage}
            setNotificationText={setNotificationAlertMessage}
          />
        }
      </DetailsSection>
      </MainDetailsSection>
    </>
  );
};

MainSection.propTypes = {
  currentPage: PropTypes.string,
  setCurrentPage: PropTypes.func
};

MainSection.defaultProps = {
  currentPage: '',
  setCurrentPage: () => {}
};
